import { ResponseKlubHome } from "@/libs/server/goApiServer/klub/KlubServiceInterface/getKlubHome";
import { ResponseKlubLifeStyleAndKlubExclusive } from "@/libs/server/goApiServer/klub/KlubServiceInterface/getKlubLifeStyleAndKlubExclusive";
import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

class KlubServiceApi {
  private baseUrl: string;

  private basePath: string;

  private basePathV3: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "klub";
    this.basePathV3 = `v3/${this.basePath}`;
  }

  // ******************************************************
  // ****************** Method: Get ***********************
  // ******************************************************

  async getKlubHome() {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV3}/home`,
      "GET",
    )) as any;

    try {
      return new ResponseKlubHome(response.data);
    } catch (error) {
      return null;
    }
  }

  async getKlubLifeStyle() {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV3}/landing`,
      "GET",
    )) as any;

    try {
      return new ResponseKlubLifeStyleAndKlubExclusive(response);
    } catch (error) {
      return {
        klub: [],
        klubExclusive: [],
      };
    }
  }
}

export default KlubServiceApi;
